export const BRAND_NAME = "Arabic Business";
export const API_URL =
  process.env.NEXT_PUBLIC_API_URL || "http://localhost:8080/api";
